const HITTA_COMPANY_BASE_URL = 'https://www.hitta.se/-/-/';
const ORDER_BASE_URL = 'https://order.hitta.se/#/order/';

const getHittaCompanyUrl = hid => `${HITTA_COMPANY_BASE_URL}${hid}`;
const getOrderUrl = orderId => `${ORDER_BASE_URL}${orderId}`;

const urlBuilder = {
    getHittaCompanyUrl,
    getOrderUrl,
};

export default urlBuilder;
